/**
 * EventEmitter.js
 * Base Event Emitter for clean event handling
 */

export default class EventEmitter {
    constructor(logger = null) {
      this.listeners = new Map();
      this.logger = logger || console;
    }
  
    on(event, callback) {
      if (!this.listeners.has(event)) {
        this.listeners.set(event, []);
      }
      this.listeners.get(event).push(callback);
      return () => this.off(event, callback);
    }
  
    off(event, callback) {
      if (this.listeners.has(event)) {
        const callbacks = this.listeners.get(event);
        const index = callbacks.indexOf(callback);
        if (index > -1) callbacks.splice(index, 1);
      }
    }
  
    async emit(event, ...args) {
      if (this.listeners.has(event)) {
        const callbacks = this.listeners.get(event);
        const results = await Promise.all(
          callbacks.map(callback => Promise.resolve(callback(...args)))
        );
        return results.find(result => result !== undefined);
      }
    }
}
